import DateFormatResolver from 'resolvers/date-format.resolver';

export default (data = [], granularity) => {
	const customersUnderAttackCounts = [];
	const labels = [];
	const dateFormat = granularity === 'hour' ? 'hA' : 'DD MMM `YY';
	for (let i = 0; i < data.length; i += 1) {
		customersUnderAttackCounts.push(data[i].customersUnderAttackCount);
		labels.push(DateFormatResolver.resolve(data[i].timeSlot, dateFormat));
	}
	const pointRadius = data.length > 50 ? 0 : 3;
	const borderWidth = data.length > 50 ? 1 : 3;
	const mainColor = '#00bcd4';

	return {
		data: {
			labels,
			datasets: [
				{
					label: 'Total',
					data: customersUnderAttackCounts,
					fill: false,
					borderColor: mainColor,
					pointBackgroundColor: mainColor,
					lineTension: false,
					pointRadius,
					borderWidth,
				},
			],
		},
		options: {
			plugins: {
				datalabels: {
					display: false,
				},
			},
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false,
			},
			scales: {
				xAxes: [
					{
						scaleShowGridLines: true,
						ticks: {
							fontColor: 'rgba(0, 0, 0, 0.2)',
							fontSize: 14,
						},
						gridLines: {
							display: false,
						},
					},
				],
				yAxes: [
					{
						ticks: {
							min: 0,
							stepSize: 1,
							beginAtZero: true,
							fontColor: 'rgba(0, 0, 0, 0.2)',
							fontSize: 14,
						},
						gridLines: {
							display: true,
							drawBorder: false,
							borderDash: [2, 2],
							color: 'rgba(0, 0, 0, 0.2)',
						},
					},
				],
			},
		},
		type: 'line',
		hasData: labels.length > 0,
	};
};
